import { Div2Floor } from "../utils/Div2Floor";
import { enumSpacingDiagram, kSpacing, kSpacingControlH } from "../constants";
import { QElement } from "./QElement";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";

export class QSpacingDiagram extends QElement {
  constructor() {
    super();
    this.fDiagram = null;
    this.fInset = 6;
    this.fMargin = 10;
    this.fIBoxWidth = 60;
    this.fIBoxHeight = 24;
  }

  InitSpacingDiagram(whichDiagram) {
    this.fDiagram = whichDiagram;
    var w = this.CalcWidth();
    var h = this.CalcHeight(whichDiagram);
    this.SizeElement(w, h);
  }

  CalcWidth() {
    return this.fInset * 2 + this.fMargin * 2 + this.fIBoxWidth;
  }

  CalcHeight(whichDiagram) {
    var h = this.fInset * 2 + this.fIBoxHeight;
    if (whichDiagram != enumSpacingDiagram.mgrspacing) h = h + this.fMargin * 2;
    return h;
  }

  FrameRect(ctx, x, y, w, h) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + w, y);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x, y + h);
    ctx.lineTo(x, y);
    ctx.closePath();
    ctx.stroke();
  }

  DrawLine(ctx, sx, sy, ex, ey) {
    ctx.beginPath();
    ctx.arc(sx, sy, 2, 0, 2 * Math.PI, false);
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();
  }

  DrawLineS(ctx, sx, sy, ex, ey) {
    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var x = this.fHorzOffset;
    var y = this.fVertOffset;
    var w = this.fWidth;
    var h = this.fHeight;
    var thickness = 1;

    ctx.lineWidth = thickness;
    ctx.lineJoin = "bevel";

    var thickAdj = ThicknessAdjuster(thickness);
    var sx = x + this.fInset + this.fMargin + thickAdj;
    var bw = this.fIBoxWidth;
    var sy = y + this.fInset + this.fMargin + thickAdj;
    if (this.fDiagram == enumSpacingDiagram.mgrspacing) sy = y + this.fInset + thickAdj;

    var bh = this.fIBoxHeight;

    //ctx.strokeStyle = "#FF0000";
    //ctx.strokeRect(x+thickAdj,y+thickAdj,w,h);
    ctx.strokeStyle = "#999999";
    ctx.fillStyle = "#999999";

    var m = this.fMargin; // + thickAdj;
    //ctx.fillStyle = "#ADD8E6";
    //ctx.fillRect(sx-m,sy-m,bw+m*2,bh+m*2);
    var my = sy + Div2Floor(bh);
    var mx = sx + Div2Floor(bw);
    switch (this.fDiagram) {
      case enumSpacingDiagram.margin:
        ctx.setLineDash([5, 2]);
        this.FrameRect(ctx, sx - m, sy - m, bw + m * 2, bh + m * 2);
        //ctx.strokeRect(sx-m,sy-m,bw+m*2,bh+m*2);
        break;
      case enumSpacingDiagram.spacing:
        ctx.setLineDash([2, 2]);
        this.DrawLine(ctx, sx - m, my, sx, my);
        this.DrawLine(ctx, sx + bw + m, my, sx + bw, my);
        this.DrawLine(ctx, mx, sy - m, mx, sy);
        this.DrawLine(ctx, mx, sy + bh + m, mx, sy + bh);
        break;
      case enumSpacingDiagram.mgrspacing:
        var v = kSpacingControlH + 2;
        this.DrawLineS(ctx, mx - v * 2, sy + bh + v, mx + v * 2, sy + bh + v);
        ctx.setLineDash([2, 2]);
        this.DrawLine(ctx, mx, sy + bh + v, mx, sy + bh);
        this.DrawLine(ctx, mx - v * 2, sy + bh + v * 2, mx - v * 2, sy + bh + v);
        this.DrawLine(ctx, mx + v * 2, sy + bh + v * 2, mx + v * 2, sy + bh + v);
        break;
    }

    ctx.setLineDash([]);
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(sx, sy, bw, bh);
    ctx.strokeStyle = this.fTextColor;
    this.FrameRect(ctx, sx, sy, bw, bh);
  }

  GetLeft(objWidth) {
    return this.GetPositionX() - objWidth;
  }

  GetRight() {
    return this.GetPositionX() + this.GetWidth();
  }

  GetMiddleX(objWidth) {
    return this.GetPositionX() + Div2Floor(this.GetWidth()) - Div2Floor(objWidth);
  }

  GetTop(objHeight) {
    return this.GetPositionY() - objHeight;
  }

  GetBottom() {
    return this.GetPositionY() + this.GetHeight();
  }

  GetBottomY1() {
    return this.GetPositionY() + this.fInset + this.fIBoxHeight;
    //return this.GetPositionY() + this.GetHeight() - this.fMargin;
  }

  GetBottomY2() {
    return this.GetBottomY1() + kSpacingControlH + 4;
    //return this.GetPositionY() + this.GetHeight() - this.fMargin + kSpacingControlH + 4;
  }

  GetMiddleY(objHeight) {
    return this.GetPositionY() + Div2Floor(this.GetHeight()) - Div2Floor(objHeight);
  }
}
